import type { FormItemRule } from 'naive-ui'
import type { MetadataTemplateField } from '@openapi'
import { MetadataTemplateFieldTypeEnum as FieldTypes } from '@openapi'

export function getValidationRules(
  field: MetadataTemplateField,
  t: (v: string) => string,
  options: { ignoreRequired?: boolean },
): FormItemRule {
  const isFieldRequired = !!field.is_required && !options?.ignoreRequired

  switch (field.type) {
    case FieldTypes.NUMBER:
      return {
        type: 'number',
        required: isFieldRequired,
        trigger: ['blur', 'change'],
        message: t('canvasUI.validations.invalidNumber'),
      }
    case FieldTypes.DATE:
      return {
        type: 'date',
        required: isFieldRequired,
        trigger: ['blur', 'change'],
        message: t('canvasUI.validations.invalidDate'),
      }
    case FieldTypes.SELECT:
      return {
        required: isFieldRequired,
        trigger: ['blur', 'change'],
        message: t('canvasUI.validations.genericIsRequired'),
      }
    case FieldTypes.MULTI_SELECT:
      return {
        type: 'array',
        required: isFieldRequired,
        trigger: ['blur', 'change'],
        message: t('canvasUI.validations.genericIsRequired'),
      }
    case FieldTypes.CHECKBOX:
      return {
        type: 'boolean',
        required: isFieldRequired,
        validator: isFieldRequired ? (_: FormItemRule, value: boolean) => !!value : undefined, // enforce true for boolean validator
        trigger: 'change',
        message: t('canvasUI.validations.genericIsRequired'),
      }
    default:
      return {
        type: 'string',
        required: isFieldRequired,
        trigger: ['blur', 'input'],
        message: t('canvasUI.validations.genericIsRequired'),
      }
  }
}
